import { render, staticRenderFns } from "./SpirometriaViewComponent.vue?vue&type=template&id=b4a49d22"
import script from "./SpirometriaViewComponent.vue?vue&type=script&lang=js"
export * from "./SpirometriaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports